import React from 'react';
import './error-screen.scss';
import { SignUpContainer } from '../sign-up-container/sign-up-container';

export const ErrorScreen: React.FC = () => {
  return (
    <SignUpContainer>
      <div className="error-screen">
        <span className="error-screen-text primary-font-semibold">
          Something Went Wrong
        </span>
      </div>
    </SignUpContainer>
  );
};
